import "@hotwired/turbo-rails"
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ToastProvider } from './contexts/ToastContext';

// This is a temporary workaround for a bug in Turbo that prevents
// form submissions from working correctly with React 18.
// See: https://github.com/hotwired/turbo/issues/395
window.addEventListener("turbo:submit-start", (event) => {
  const { formSubmission } = event.detail;
  const { formElement, submitter } = formSubmission;

  if (formElement.matches('[data-turbo="true"]')) {
    event.preventDefault();
    formElement.requestSubmit(submitter);
  }
});

document.addEventListener('turbo:load', () => {
  const rootEl = document.getElementById('react-homepage');
  if (rootEl) {
    const root = createRoot(rootEl)
    root.render(
      <React.StrictMode>
        <ToastProvider>
          <App />
        </ToastProvider>
      </React.StrictMode>
    );
  }
});
